module.exports = __webpack_public_path__ + "img/base-map-basic.e5ce8d71.png";